import prepare from './prepare'

export default {
  mixins: [prepare],
  data: () => ({
    // 为了避免同时请求多个需要认证的接口时重复触发deactivating
    deactivating: false
  }),
  methods: {
    activate () {
      return Promise.resolve().then(() => {
        return this.getUser()
      }).then(() => {
        return this.toggleSubscribe('MQTT_SUBSCRIBE')
      }).then(() => {
        return this.prepareData()
      }).then(() => {
        return this.$router.replace(localStorage.getItem('path') || '/home')
      }).then(() => {
        return 0 || this.$bus.$emit('activated')
      }).catch(() => {})
    },
    getUser () {
      return this.$http.post('/base/auth/user').then(response => {
        const user = _.get(response.data, 'data')

        this.$store.commit('assignValue', {
          user: user,
          csrfToken: _.get(response.data, 'csrf_token')
        })
      })
    },

    deactivate () {
      this.deactivating = true

      // 因为是主动失活，需要清除mqtt相关认证资料
      return Promise.resolve().then(() => {
        return this.$router.replace('/auth')
      }).then(() => {
        return this.toggleSubscribe('MQTT_UNSUBSCRIBE')
      }).then(() => {
        return this.removeUser()
      }).catch(() => {}).finally(() => {
        this.deactivating = false
      })
    },
    removeUser () {
      return this.$http.post('/base/auth/logout').catch(() => {}).finally(() => {
        this.$store.commit('assignValue', {
          user: null
        })
      })
    },

    toggleSubscribe (action) {
      return Promise.resolve().then(() => {
        this.$store.commit(action, `/${this.user.id}`)
        this.$store.commit(action, `/${this.user.id}/message`)
      })
    }
  }
}
